var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-time-select',{attrs:{"picker-options":{
      start: '00:00',
      step: '00:15',
      end: '23:45'
    },"placeholder":"Select time"},model:{value:(_vm.currentField.value),callback:function ($$v) {_vm.$set(_vm.currentField, "value", $$v)},expression:"currentField.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }